import {Flex, Text, Box, useDisclosure, Divider} from '@chakra-ui/react';
import {IconMenu2} from '@tabler/icons';
import Link from 'next/link';
import {NavBarMobileMenu} from './nav-bar-mobile-menu';
import {LinkButton} from './link-button';
import {Logo} from './logo';

interface ProductMobileNavBarProps {
  username?: string;
  background?: string;
  headerBaseText?: string;
  accent: string;
  variant?: 'light' | 'dark';
  productLink: string;
  purchaseLink: string;
  activeLink: string;
  hideSubNav?: boolean;
}

export const ProductMobileNavBar: React.FC<ProductMobileNavBarProps> = ({
  username,
  background,
  headerBaseText = 'Edward VIII Penny',
  accent,
  variant = 'dark',
  productLink,
  purchaseLink,
  activeLink,
  hideSubNav,
}) => {
  const {isOpen, onOpen, onClose} = useDisclosure();

  return (
    <>
      <Box
        position="fixed"
        top="0"
        left="0"
        zIndex="banner"
        width="100%"
        bg={variant === 'dark' ? background : 'white'}
      >
        <Flex flexDir="column" display={{base: 'flex', lg: 'none'}}>
          <Flex
            display={{base: 'flex', lg: 'none'}}
            justifyContent="space-between"
            alignItems="center"
            p="16px"
          >
            <Box>
              <IconMenu2
                size="32px"
                color={variant === 'dark' ? 'white' : 'black'}
                stroke="2"
                onClick={onOpen}
              />
              <NavBarMobileMenu
                username={username}
                isOpen={isOpen}
                onClose={onClose}
                onOpen={onOpen}
              />
            </Box>
            <Text
              color={variant === 'dark' ? 'white' : 'black'}
              textStyle="h4_1c"
              textAlign="center"
            >
              {headerBaseText}
            </Text>
            <Link href="/">
              <a style={{lineHeight: 0}}>
                <Box width="42px" height="42px">
                  <Logo
                    base={variant === 'dark' ? 'white' : 'black'}
                    accent={accent}
                  />
                </Box>
              </a>
            </Link>
          </Flex>
          {!hideSubNav && (
            <Flex pt={{base: '8px'}} justifyContent="center">
              <LinkButton
                buttonBgColor="transparent"
                buttonText="The Story"
                buttonWrapperStyles={{mr: '40px'}}
                buttonHref={`/${productLink}`}
                isActive={productLink === activeLink}
              />

              <LinkButton
                buttonBgColor="transparent"
                buttonText="Buy Pieces"
                buttonHref={`/${purchaseLink}`}
                isActive={purchaseLink === activeLink}
              />
            </Flex>
          )}
          <Divider color="tone6" />
        </Flex>
      </Box>
    </>
  );
};
